/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import findIndex from 'lodash/findIndex';
import {
    CLEAR_RESERVATION_ERRORS,
    CREATE_RESERVATION,
    CREATE_RESERVATION_ERROR,
    CREATE_RESERVATIONS_ERROR,
    DELETE_RESERVATION,
    DELETE_RESERVATION_ERROR,
    GET_AVAILABLE_PRICE_ERROR,
    GET_CAMPING_PERMIT_PDF_ERROR,
    GET_RESERVATION,
    GET_RESERVATION_ERROR,
    GET_RESERVATION_PRICE_DETAILS,
    GET_RESERVATION_PRICE_DETAILS_ERROR,
    SAVE_RESERVATIONS,
    UNDO_RESERVATION_ERROR,
    UPDATE_RESERVATION,
    UPDATE_RESERVATION_ERROR,
} from '../../shared/constants';

const INITIALSTATE = {
    reservation: {},
    list: [],
};

export default function reservations(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case GET_RESERVATION:
            delete st.err;
            st.reservation = action.payload;
            return st;

        case GET_RESERVATION_ERROR:
            delete st.err;
            st.err = action.err;
            return st;

        case CREATE_RESERVATION:
            delete st.err;
            st.reservation = action.payload;
            return st;

        case CREATE_RESERVATION_ERROR:
            delete st.err;
            st.err = action.error;
            return st;

        case CREATE_RESERVATIONS_ERROR:
            delete st.err;
            st.err = action.error;
            return st;

        case UPDATE_RESERVATION: {
            delete st.err;
            const index = findIndex(st.list, (item) => {
                return item.reservation.campsite_id === action.payload.campsite_id;
            });
            if (index >= 0) {
                st.list = st.list.map((item, i) =>
                    i === index ? { reservation: action.payload } : item
                );
            }
            return st;
        }

        case UPDATE_RESERVATION_ERROR:
            delete st.err;
            st.err = action.error;
            return st;

        case DELETE_RESERVATION:
            delete st.err;
            st.deleted = action.payload;
            return st;

        case DELETE_RESERVATION_ERROR:
            delete st.err;
            st.err = action.payload;
            return st;

        case UNDO_RESERVATION_ERROR:
            delete st.err;
            st.err = action.payload;
            return st;

        case CLEAR_RESERVATION_ERRORS:
            delete st.err;
            return st;

        case SAVE_RESERVATIONS:
            st.list = action.payload;
            return st;

        case GET_AVAILABLE_PRICE_ERROR:
            delete st.err;
            st.err = action.error;
            return st;
        case GET_RESERVATION_PRICE_DETAILS:
            delete st.err;
            st.priceDetails = action.payload;
            return st;
        case GET_RESERVATION_PRICE_DETAILS_ERROR:
            delete st.err;
            st.err = action.error;
            return st;

        case GET_CAMPING_PERMIT_PDF_ERROR:
            delete st.err;
            st.err = action.error;
            return st;

        default:
            return st;
    }
}
